
export default {
  data() {
    return {
      inView: false,
      options: [{ name: "logo", label: "Logo", type: "image" }],
    };
  },
};
